<template>
  <div id="app">
    <van-nav-bar
      fixed
      placeholder
      z-index="9"
      :title="$route.meta.title || $store.state.encodeInfo.zhangtao"
      :left-text="$route.meta.showBack === false ? '' : '返回'"
      :left-arrow="$route.meta.showBack !== false"
      @click-left="$router.back()"
      v-if="$route.meta.showNavBar !== false"
    />
    <router-view class="router-view" />
    <my-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  components: {
    MyFooter: Footer
  },
  data() {
    return {}
  },
  created() {}
}
</script>

<style lang="less">
.router-view {
  min-height: calc(100vh - 86px);
}
</style>
